<template>
  <div>

    <!-- 배달 -->
    <delivery-info
      :selected-delivery-address="deliveryAddress"
      @store-delivery-info="storeDeliveryInfo"
      v-if="isDelivery"
    />

    <!-- 픽업 -->
    <pick-up :selected-delivery-address="deliveryAddress" v-if="isPickUp"  :abc-id="abcId" />

  </div>

</template>

<script>
import DeliveryInfo from "@/views/order/main/components/Receive/DeliveryInfo";
import PickUp from "@/views/order/main/components/Receive/PickUp";

export default {
  name: "ReceiveMethods",
  components: {PickUp, DeliveryInfo},
  props: {
    receiveMethod: {
      type: String,
      required: true
    },
    deliveryAddress: {
      type: Object,
      required: true,
      default: () => {
        return {
          cellphone: "01012345678",
          formattedAddress: "서울시 강남구 삼성동 159 아셈타워 28층",
          id: "8944827006999",
          name: "테스트 배송지",
          postalCode: "06164",
          message: "",
        }
      }
    },
    abcId: {
      type: String,
      required: true
    }
  },
  methods: {
    storeDeliveryInfo(event) {
      this.$emit('store-delivery-info', event);
    }
  },
  computed: {
    isDelivery() {
      return this.receiveMethod === "VCALL";
    },
    isPickUp() {
      return this.receiveMethod === "ABC";
    },
  }
}
</script>

<style scoped>

</style>
